import { ReactElement } from 'react';

import { TableCell } from '@mui/material';

import { ASPECT_RATIO_TYPES } from '@app/components/common/ImageSelector/ImageSelector';
import { RegularText } from '@app/components/common/RegularText';
import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface TitleWithImageCellProps {
  column: ColumnInterface;
  row: GenericObject;
}

const THUMBNAIL = {
  WIDTH: 85,
};

const DEFAULT = {
  WIDTH: 50,
  HEIGHT: 50,
};

export const TitleWithImageCell = ({ column, row }: TitleWithImageCellProps) => {
  return (
    <TableCell align="left">
      <div className="default-table_title-container">
        {column.getImagePath && (
          <>
            <link
              rel="preload"
              as="image"
              href={`${column.getImagePath(row) as string}`}
              style={{
                width: column.aspectRatio === ASPECT_RATIO_TYPES.THUMBNAIL ? THUMBNAIL.WIDTH : DEFAULT.WIDTH,
                height: DEFAULT.HEIGHT,
              }}
              className="default-table_img"
            />
            <img
              src={`${column.getImagePath(row) as string}`}
              alt="ImageTitle"
              height={DEFAULT.HEIGHT}
              width={column.aspectRatio === ASPECT_RATIO_TYPES.THUMBNAIL ? THUMBNAIL.WIDTH : DEFAULT.WIDTH}
              className="default-table_img"
            />
          </>
        )}
        <RegularText sx={{ marginLeft: 2 }}>
          {column.format ? column.format(row) : (row[column.key] as ReactElement)}
        </RegularText>
      </div>
    </TableCell>
  );
};
